import { render, staticRenderFns } from "./user-info-dialog.vue?vue&type=template&id=05df28dc&scoped=true&"
import script from "./user-info-dialog.vue?vue&type=script&lang=js&"
export * from "./user-info-dialog.vue?vue&type=script&lang=js&"
import style0 from "./user-info-dialog.vue?vue&type=style&index=0&id=05df28dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df28dc",
  null
  
)

export default component.exports